// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mx-datepicker {\n  width: 100% !important;\n}\n.inputClass {\n  width: 100% !important;\n  padding: 0px 3px 0px 10px !important;\n}", ""]);
// Exports
module.exports = exports;
